<template>
    <!-- About section start -->
	<section id="about-section" class="px-4 lg:px-32 py-16">
        <div class="max-w-7xl mx-auto">
            <!-- Grid container -->
            <div class="grid md:grid-cols-2 gap-8 items-center">
                <!-- Text content -->
                <div class="order-2 md:order-2">
                    <template v-if="isLoading">
                        <LoadingSkeleton size="xl" class="mb-4"/>
                        <LoadingSkeleton size="md" class="mb-2"/>
                        <LoadingSkeleton size="md" class="mb-2"/>
                        <LoadingSkeleton size="md" class="mb-2"/>
                        <LoadingSkeleton size="md" class="w-2/3"/>
                    </template>
                    <template v-else>
                        <h1 class="uppercase text-3xl md:text-5xl text-pink mb-4 font-semibold">
                            {{ about.title }}
                        </h1>
                        <p class="text-pink font-medium">
                            {{ extractText(about.biography) }}
                        </p>
                    </template>
                </div>
                
                <!-- Image container -->
                <div class="order-1 md:order-1">
                    <div class="aspect-square overflow-visible p-4">
                        <template v-if="isLoading">
                            <LoadingSkeleton class="w-full h-full flower-mask"/>
                        </template>
                        <template v-else>
                            <img 
                                :src="about.profileImage?.fields?.file?.url" 
                                :alt="about.profileImage?.fields?.title" 
                                class="w-full h-full object-cover flower-mask"
                            >
                        </template>
                    </div>
                </div>
            </div>
        </div>
	</section>
	<!-- About section end -->
</template>

<script>
import { contentfulClient } from '@/config/contentful'
import LoadingSkeleton from '@/components/LoadingSkeleton.vue'

export default {
    name: 'AboutSection',
    components: {
        LoadingSkeleton
    },
    data() {
        return {
            isLoading: true,
            about: {
                title: '',
                biography: '',
                profileImage: null
            }
        }
    },
    methods: {
        extractText(richText) {
            if (!richText || !richText.content) return ''
            return richText.content
                .map(item => item.content?.map(subItem => subItem.value).join(''))
                .join('\n')
                .trim()
        }
    },
    async created() {
        try {
            const response = await contentfulClient.getEntries({
                content_type: 'about',
                limit: 1
            })
            
            if (response.items && response.items.length > 0 && response.items[0].fields) {
                this.about = response.items[0].fields
            }
        } catch (error) {
            console.error('Error fetching about section:', error)
        } finally {
            this.isLoading = false
        }
    }
}
</script>

<style scoped>
.flower-mask {
    border-radius: 63% 37% 54% 46% / 55% 48% 52% 45%;
    transition: all 0.8s ease-in-out;
    transform-origin: center center;
}

.flower-mask:hover {
    border-radius: 40% 60% 35% 65% / 45% 45% 55% 55%;
    transform: scale(1.05);
}
</style>
